import React, { useEffect, useState } from 'react';
import {
  fetchComplianceNotifications,
  getComplianceNotifications,
  updateComplianceNotifications,
} from 'src/compliance';
import { getUser } from 'src/user';
import { connect } from 'react-redux';
import { getToken } from 'src/auth';
import { toast } from 'react-toastify';
import { InnerLoader, UiToastAdapter } from 'src/ui';
import propTypes from 'prop-types';
import { ComplianceNotificationsTable } from '../components';

function NotificationSettingsPage({
  user,
  token,
  fetchComplianceNotifications,
  updateComplianceNotifications,
  notifications,
}) {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      setLoading(true);
      if (token.isValid()) {
        await fetchComplianceNotifications({
          financialInstitutionId: user.financialInstitutionId,
          userId: user.id,
        }).then(() => setLoading(false));
      }
    })();
  }, []);

  const updateNotifications = async data => {
    setLoading(true);
    await updateComplianceNotifications({
      financialInstitutionId: user.financialInstitutionId,
      userId: user.id,
      data,
    }).then(response =>
      response.error
        ? toast(
            UiToastAdapter(
              'An Error Occured While Updating Notification Settings',
              'danger'
            )
          )
        : toast(
            UiToastAdapter(
              'Notification Settings Successfully Updated',
              'success'
            )
          )
    );

    setLoading(false);
  };
  return (
    <>
      {!loading && !notifications.isLoading() && (
        <ComplianceNotificationsTable
          data={notifications.complianceNotifications}
          updateNotifications={updateNotifications}
        />
      )}
      <InnerLoader visible={loading} />
    </>
  );
}

function mapStateToProps(state) {
  return {
    user: getUser(state),
    token: getToken(state),
    notifications: getComplianceNotifications(state),
  };
}

const connectedNotificationSettingsPage = connect(mapStateToProps, {
  fetchComplianceNotifications,
  updateComplianceNotifications,
})(NotificationSettingsPage);

export { connectedNotificationSettingsPage as NotificationSettingsPage };

NotificationSettingsPage.propTypes = {
  user: propTypes.object.isRequired,
  token: propTypes.object.isRequired,
  fetchComplianceNotifications: propTypes.func.isRequired,
  updateComplianceNotifications: propTypes.func.isRequired,
  notifications: propTypes.object.isRequired,
};
